import React, { useEffect } from "react";
import PropTypes from "prop-types";
import sal from "sal.js";

import Header from "./header";
import Footer from "./footer";

const Layout = ({ children, menu, footer, translations }) => {
    // Initialize scroll animations
    useEffect(() => {
        sal();
    }, []);

    return (
        <div className="wrapper overflow-hidden">
            <Header menu={menu} translations={translations} />
            <div className="pt-20">{children}</div>
            <Footer content={footer} />
        </div>
    );
};

Layout.defaultProps = {
    menu: null,
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    menu: PropTypes.any,
};

export default Layout;
